module.exports = __webpack_public_path__ + "static/img/com3.449458b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/product/components/imgs/com3.jpg
// module id = rP+y
// module chunks = 1